/* eslint-disable no-undef */
// remove no-js flag
$('html').removeClass('no-js');

$(document).ready(() => {
  initMobileMenu();
  initFancybox();
  initSlider();
  initParallax();
  initSmallLayoutAnimations();
  initTextTeaserEqHeight(false);
});

// FIX wrong 100vh in iOS and android jumps when the url bar hides
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
const vh = window.innerHeight * 0.01;
// this is than used as var inside css/less
document.documentElement.style.setProperty('--vh', `${vh}px`);

// submit job searchform on not job list pages
$('.job-search-form .btn-submit').on('click', function (e) {
  let thisForm = $(this).parents('form[data-job-search-form]');
  let url = thisForm.attr('action') + '?';
  let i = 0;
  thisForm.find('input[data-api-name]').each(function () {
    if (i > 0) {
      url += '&';
    }
    url += $(this).data('apiName') +'='+ $(this).val();
    i++;
  });
  location.href = url;
});


$('#customJobofferFormModal').on('show.bs.modal', function (event) {
  let joboffersField = $(this).find('#powermail_field_stellentitel');
  let chosenOfferItem = $(event.relatedTarget).parents('.joboffer-item');

  $(event.relatedTarget).parents('.joboffer-wrapper').children('.joboffer-item').each(function (e) {
    let offerText = $(this).find('.joboffer-title').text();
    let dataUid = 'data-uid="'+ $(this).data('uid') +'"';
    let dataOffer = 'data-joboffer="'+ $(this).data('joboffer') +'"';

    if (joboffersField.children('option['+ dataUid +']['+ dataOffer +']').length === 0) {
      joboffersField.append('<option value="'+ offerText +'" '+ dataUid +' '+ dataOffer +'>'+ offerText +'</option>');
    }
  });

  joboffersField.children('option[data-uid="'+ chosenOfferItem.data('uid') +'"][data-joboffer="'+ chosenOfferItem.data('joboffer') +'"]').attr('selected', 'selected');
}).on('hidden.bs.modal', function (event) {
  let joboffersField = $(this).find('#powermail_field_stellentitel');
  joboffersField.children('option[data-joboffer]').remove();
});

const navbarTransitionSpeed = 400;
const vpChangeWidth = 1200;
var isMobile = checkMobile();

$(function () {
  isMobile = checkMobile();
  scrollTop();

  // toggleNav();
  // animateMobileNavbar();
  setThinClassAndHeight();
  toggleLvl1UlClass();
  animateDesktopNavbar();
  setViewportSizeQuery();
  toggleSidebar();
});

function checkMobile() {
  return window.innerWidth < vpChangeWidth;
}

function setThinClassAndHeight() {
  let navbar = $('.main-navbar');
  // normal height Wert direkt zum Anfang holen, weil sonst im else die Transition aus dem CSS noch wirkt
  // und die Höhe manipuliert
  let scrollValue = navbar.outerHeight();

  $(window).on('scroll',function () {
    if (checkMobile() === false) {
      if ($(this).scrollTop() >= scrollValue) {
        navbar.addClass("thin");
      } else {
        navbar.removeClass("thin");
      }
    }
  });
}

function scrollTop() {
  $(document).on('click', ".ce-f-top-btn", function (e) {
    e.preventDefault();
    $('html, body').animate({scrollTop: 0}, '200');
  });
}

// function animateMobileNavbar() {
//   //animate main list:--------------------
//   $(document).on('click', ".n-burger", function () {
//     let ul = $('.n-lvl-0');
//
//     $('.main-navbar').css('height', '');
//
//     if (ul.hasClass('show')) {
//       ul.slideDown(navbarTransitionSpeed);
//     } else {
//       let subLvls = $('.n-lvl-1, .n-lvl-over1');
//       if (subLvls.hasClass("show")) {
//         let buttons = $('.n-lvl-0').find('.lvl-0-button.rotate')
//         buttons.removeClass('rotate');
//         subLvls.slideUp(navbarTransitionSpeed);
//         subLvls.removeClass('show');
//       }
//       ul.slideUp(navbarTransitionSpeed);
//     }
//   });
//
//   //animate sub list:-------------------------
//   let lvl0Items = $('.main-navbar').find('.lvl-0-item');
//
//   lvl0Items.each(function () {
//     if ($(this).find('.n-lvl-1').length > 0) {
//
//       $(document).on('click', ".lvl-0-button", function () {
//         let subLvlWrapper = $(this).siblings('.n-lvl-1, .n-lvl-over1');
//
//         if (subLvlWrapper.hasClass('show')) {
//           $(this).addClass('rotate');
//           subLvlWrapper.slideDown(navbarTransitionSpeed);
//         } else {
//           $(this).removeClass('rotate');
//           subLvlWrapper.slideUp(navbarTransitionSpeed);
//         }
//       });
//     }
//   });
// }

function animateDesktopNavbar() {
  if (isMobile === false) {
    let mainNavbar = $('.main-navbar');
    let lvl0Items = mainNavbar.find('.lvl-0-item');

    mainNavbar.css('height', '');
    if (mainNavbar.find('.n-lvl-0, .n-lvl-1, .n-lvl-over1').hasClass('show') === true) {
      mainNavbar.find('.n-lvl-0, .n-lvl-1, .n-lvl-over1').css('height', '').removeClass('show');
    }
  }
}

// function toggleNav() {
//   $(document).on('click', ".n-burger", function () {
//     $(this).toggleClass('opened');
//     $('.n-lvl-0').toggleClass('show');
//   });
// }

function toggleLvl1UlClass() {
  $(document).on('click', ".lvl-0-button", function () {
    $(this).siblings('.n-lvl-1, .n-lvl-over1').toggleClass('show');
  });
}

function setViewportSizeQuery() {
  let ViewportSize = window.innerWidth;

  $(window).resize(function () {
    ViewportSize = window.innerWidth;
    isMobile = checkMobile();

    if (isMobile === true) {
      $('.main-navbar').css('height', '');
    } else {
      animateDesktopNavbar();
    }
  });
}

function toggleSidebar() {
  if ($('.ce-sidebar').length > 0) {
    if (isMobile === true) {
      $('.ce-sidebar .ce-s-arrow').addClass('collapsed');
    }
    $(document).on('click', '.ce-s-arrow', function (e) {
      $(this).toggleClass('collapsed');
    });
    $(document).on('click', '.ce-s-c-wrapper', function (e) {
      $(this).parents('.ce-s-contact').addClass('open');
    });
    $(document).on('click', '.ce-s-c-formclose', function (e) {
      $(this).parents('.ce-s-contact').removeClass('open').addClass('closed');
      setTimeout(() => {
        $(this).parents('.ce-s-contact').removeClass('closed');
        document.activeElement.blur();
      }, 900);
    });

    if($('.ce-s-contact .powermail_create').length > 0) {
      $('.ce-s-contact').addClass('open');
    }
  }
}
